$(document).ready(function() {

  // Date Pickers
  $(".datepicker").each(function() {

    // Initialize a datepicker
    var tempDate = $(this).val();
    $(this).datepicker();

    // Only preset a date if one exists
    if (tempDate != "") {

      var dateParts = tempDate.split('/');
      var thisDate = new Date(dateParts[2], dateParts[0] - 1, dateParts[1]);

      $(this).datepicker("setDate", thisDate);

    }

  });

  // DateTime Pickers
  $('.datetimepicker').datetimepicker({
    timeFormat: "hh:mm tt"
  });

  // File Picker Label update
  $("input[type=file]").change(function() {
    var fieldVal = $(this).val();

    fieldVal = fieldVal.replace("C:\\fakepath\\", "");

    if (fieldVal != undefined || fieldVal != "") {
      $(this).next(".custom-file-label").attr('data-content', fieldVal);
      $(this).next(".custom-file-label").text(fieldVal);
    }
  });

  // Filters
  $(".filter-toggle").click(function() {
    $(".filter-form").toggle();
  });
  $(".filter-run").click(function() {

    // Start animation
    $(".filter-results tbody").html('<tr><td colspan="' + $(".filter-results thead tr th").length + '" align="center"><span class="glyphicon glyphicon-repeat glyphicon-spin"></span></td></tr>');

    // Run the Ajax filter
    $.get($(".filter-form").attr("action") + "?" + $(".filter-form").serialize())
      .done(function(data) {

        $(".filter-results tbody").html(data);

      })
      .fail(function(data) {

        console.log('Filter Error: ' + data); // An error occurred during the request.
        $(".filter-results tbody").html('<tr><td colspan="' + $(".filter-results thead tr th").length + '" align="center">' + 'Filter Error: ' + data + '</td></tr>');

      });

  });

  //Popovers
  $(function() {
    $('[data-toggle="popover"]').popover()
  })

  // Positionable
  $(".table-positionable tbody").sortable({
    cursor: 'pointer',
    placeholder: 'placeholder',
    update: function(event, ui) {
      var data = $(this).parent().children("tbody").sortable('serialize');
      //alert($(this).parent().attr("data-sortable")+"?"+data);
      $.get($(this).parent().attr("data-positionable") + "?" + data);
    }

  }).disableSelection();

  // Slugs
  if ($(".slugpart").length) {

    // First disable by default for existing records
    if ($("#slugUnlock").length) {
      $("#slug").prop('disabled', true);

      $("#slugUnlock").click(function() {
        $("#slug").prop('disabled', false);
        $("#slugUnlockToggle").prop('disabled', true);
      });
    } else {

      // Setup slug part listeners
      $(".slugpart").keyup(function() {

        if ($("#slug").prop('disabled') == false) {

          var newSlug = "";
          for (sp = 1; sp <= $(".slugpart").length; sp++) {

            var newSlugPart = $(".slugpart-" + sp).val();

            newSlugPart = newSlugPart.trim(); // Remove surrounding whitespace
            newSlugPart = newSlugPart.toLowerCase(); // Convert to lowercase
            newSlugPart = newSlugPart.replace(/[^a-z0-9]+/g, '-') // Replace invalids with dash
            newSlugPart = newSlugPart.replace(/^-+/, '') // Remove all dashes from the beginning of the string
            newSlugPart = newSlugPart.replace(/-+$/, ''); // Remove all dashes from the end of the string

            newSlug += newSlugPart + "-";
          }

          newSlug = newSlug.replace(/-+$/, ''); // Remove final trailing dash

          // Re-populate slug
          $("#slug").val(newSlug);

        }

      });

    }

  }

  // Sortable Setup (ordering of results)
  if ($(".table-sortable").length) {

    var sortableIcon = '<i class="fas fa-sort"></i>';
    var sortableASC = '<i class="fas fa-sort-up"></i>';
    var sortableDESC = '<i class="fas fa-sort-down"></i>';

    // Default sortable icon
    $(".sortable-toggle").append(sortableIcon);

    // Current sortable icon
    $(".sortable-toggle").each(function() {
      console.log($(this).attr("data-column") + ' | ' + $("#sort-column").val());
      if ($(this).attr("data-column") == $("#sort-column").val()) {

        $(this).children(".fas").remove();
        if ($("#sort-order").val() == "asc") {
          $(this).append(sortableASC);

        } else {
          $(this).append(sortableDESC);

        }

      } else {
        console.log('no match');
      }

    });



    $(".sortable-toggle").click(function() {

      // Handle column
      $("#sort-column").val($(this).attr("data-column"));

      // Handling ordering
      if ($(this).children(".fa-sort").length) {

        // Reset other sortable table columns
        $(".fa-sort-up").each(function() {
          var tempParent = $(this).parent();
          $(this).remove();
          tempParent.append(sortableIcon);
        });
        $(".fa-sort-down").each(function() {
          var tempParent = $(this).parent();
          $(this).remove();
          tempParent.append(sortableIcon);
        });

        // No Sort, change to ASC
        $(this).children(".fa-sort").remove();
        $(this).append(sortableASC);
        $("#sort-order").val("asc");

      } else if ($(this).children(".fa-sort-up").length) {
        $(this).children(".fa-sort-up").remove();
        $(this).append(sortableDESC);
        $("#sort-order").val("desc");
      } else if ($(this).children(".fa-sort-down").length) {
        $(this).children(".fa-sort-down").remove();
        $(this).append(sortableASC);
        $("#sort-order").val("asc");
      } else {
        console.log("sorting issue...")
      }

      var columnCount = $(".table-sortable thead tr:first th").length;
      console.log(columnCount);
      $(".table-sortable tbody").html('<tr><td colspan="' + columnCount + '" align="center"><i class="fas fa-circle-notch fa-spin fa-3x mb-5 mt-5"></i><span class="sr-only">Loading...</span></td></tr>');

      $(".filters-form").submit();


    });

  }



  // Tabs Setup
  $("ul.nav-tabs a").click(function(e) {
    e.preventDefault();
    $(this).tab('show');
  });

});



// WEBPACK FOOTER //
// ./resources/assets/js/admin/global.js